export  const ROUTES  = {
    HOME: '/',
    CARD: '/cart',
    PROFILE: '/profile',
    PRODUCT: '/products/:id',
    CATEGORY: '/categories/:id',
    HELP: '/help',
    TERMS: '/terms',
}